module.exports = __webpack_public_path__ + "img/cc.5e3c5ec4.svg";